import CalendarEvent from 'packages/common/controls/packages/types/owa-calendar-types/src/types/CalendarEvent';

export function shouldCreateCollabObject(event: CalendarEvent): boolean {
    return (
        event &&
        !event.IsDraft &&
        (!event.CollabSpace?.changeKey || event.CollabSpace?.changeKey?.length === 0)
    );
}
